module.exports = __webpack_public_path__ + "static/media/parking.3a2b230f.svg";